<template>

    <KedvezmenyekBase>

        <v-layout row wrap slot="kedvezmeny" ref="kedvezmeny" style="max-width: 100%;">

            <BnFormField v-if="kobepartnerVisible()" :attributes="kobepartner" />

            <BnFormField v-if="kobetagsagVisible()" :attributes="kobetagsag" />

            <BnFormField v-if="takarekVisible()" :attributes="takerek" />

            <BnFormField v-if="negytengelyVisible()" :attributes="negytengely" />

            <BnFormField v-if="jogositvanyVisible()" :attributes="jogositvany" />

            <BnFormField v-if="bankszlaVisible()" :attributes="bankszla" />

        </v-layout>

    </KedvezmenyekBase>

</template>

<script>
import BnFormField from '../../../../../../basecomponents/BnFormField.vue';
import { SZGK, TEHER, VONTATO } from '../../../../../../../modules/Gepjarmu';
import Kedvezmeny from '../../../../mixins/dijak/kedvezmenyek/Kedvezmeny';
import KedvezmenyekBase from '../KedvezmenyBase.vue';

export default {
    name: 'KedvezmenyekB15',
    components: {
        KedvezmenyekBase,
        BnFormField,
    },
    mixins: [Kedvezmeny],
    methods: {
        kobepartnerVisible() {
            return [SZGK, VONTATO, TEHER].includes(this.getValue('gepjarmu.fajta'));
        },
        kobetagsagVisible() {
            return [SZGK, VONTATO, TEHER].includes(this.getValue('gepjarmu.fajta'));
        },
        takarekVisible() {
            return this.getValue('gepjarmu.fajta') === SZGK;
        },
        negytengelyVisible() {
            return this.getValue('gepjarmu.fajta') === TEHER;
        },
        jogositvanyVisible() {
            return this.getValue('gepjarmu.fajta') === SZGK
                && this.$store.getters.uzembentarto.has_licence
                && parseInt(this.$store.getters.tarifaData.ajanl_kock_kezd, 10) >= 20220115;
        },
        bankszlaVisible() {
            return this.getValue('gepjarmu.fajta') === SZGK
                && parseInt(this.$store.getters.tarifaData.ajanl_kock_kezd, 10) >= 20251001;
        },
    },
    data() {
        return {
            takerek: {
                type: 'checkbox',
                label: 'Takarékszövetkezeti kedvezmény (szgk)',
                visible: true,
                editable: !this.disabled,
                help: true,
                path: 'kedvezmenyekbiztosito.15.takarek',
                mezo: 'kobe_takarek',
                change: this.shouldRecalc,
            },
            negytengely: {
                type: 'checkbox',
                label: 'Négytengelyes kedvezmény',
                visible: true,
                editable: !this.disabled,
                help: true,
                path: 'kedvezmenyekbiztosito.15.negytengely',
                mezo: 'kobe_negytengely',
                change: this.shouldRecalc,
            },
            kobepartner: {
                type: 'checkbox',
                label: 'Partnerkedvezmény',
                visible: true,
                editable: !this.disabled,
                help: true,
                path: 'kedvezmenyekbiztosito.15.kobepartner',
                mezo: 'kobe_kobepartner',
                change: this.shouldRecalc,
            },
            kobetagsag: {
                type: 'checkbox',
                label: 'Tagsági kedvezmény',
                visible: true,
                editable: !this.disabled,
                help: true,
                path: 'kedvezmenyekbiztosito.15.kobetagsag',
                mezo: 'kobe_kobetagsag',
                change: this.shouldRecalc,
            },
            jogositvany: {
                type: 'checkbox',
                label: 'Igénybe veszem a jogosítvány kedvezményt',
                visible: true,
                editable: !this.disabled,
                help: true,
                path: 'kedvezmenyekbiztosito.15.jogositvany',
                mezo: 'kobe_jogositvany',
                change: this.shouldRecalc,
            },
            bankszla: {
                type: 'checkbox',
                label: 'Bankszámla kedvezmény',
                visible: true,
                editable: !this.disabled,
                help: true,
                path: 'kedvezmenyekbiztosito.15.bankszla',
                mezo: 'kobe_bankszla',
                change: this.shouldRecalc,
            },
        };
    },
};
</script>
